// Site-wide smooth (inertia) scrolling, replacing the smooth scroll the
// original Framer runtime provided. Lenis still drives the page's native
// scroll position, so `scroll` events, IntersectionObserver reveals and
// position: sticky/fixed all keep working as before.
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

let lenis = null;
let rafId = 0;

export function startSmoothScroll() {
  if (lenis) return lenis;
  // Respect users who've asked their OS for less motion.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

  lenis = new Lenis({
    lerp: 0.1, // how quickly scrolling catches up; lower = floatier
    smoothWheel: true,
    anchors: true, // smooth-scroll in-page "#section" links
  });

  const raf = (time) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);
  return lenis;
}

export function stopSmoothScroll() {
  cancelAnimationFrame(rafId);
  if (lenis) lenis.destroy();
  lenis = null;
}

// Popups/menus call these while open, because Lenis ignores
// `body { overflow: hidden }` scroll locks.
export function pauseScroll() {
  if (lenis) lenis.stop();
}
export function resumeScroll() {
  if (lenis) lenis.start();
}

// Jump instantly (no animation), e.g. to the top on route change.
export function jumpTo(y = 0) {
  if (lenis) lenis.scrollTo(y, { immediate: true, force: true });
  else window.scrollTo(0, y);
}
